import { render, staticRenderFns } from "./BorderTableDevice.vue?vue&type=template&id=4b7c9c32&scoped=true&"
import script from "./BorderTableDevice.vue?vue&type=script&lang=js&"
export * from "./BorderTableDevice.vue?vue&type=script&lang=js&"
import style0 from "./BorderTableDevice.vue?vue&type=style&index=0&id=4b7c9c32&lang=scss&scoped=true&"
import style1 from "./BorderTableDevice.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b7c9c32",
  null
  
)

export default component.exports